<!--常见的左边某个树右边是内容的结构
-->
<template>
	<div class="treeBody" ref="box">
		<slot></slot>
		<div ref="left" class="tree">
			<slot name="tree" ></slot>
			<slot name="checkBoxTree" ></slot>
		</div>
		<div ref="resize" @mousedown="drag($event)" id="resize">
		</div>
		<div ref="right" class="body">
			<slot name="body"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			canDrag:{
				type: Boolean,
				default: true
			},
		},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			drag(e) {
				if(!this.canDrag){
					return
				}
				var resize = this.$refs.resize
				var left = this.$refs.left
				var right = this.$refs.right
				var box = this.$refs.box
				var startX = e.clientX + box.offsetLeft;
				resize.left = resize.offsetLeft;
				document.onmousemove = function(e) {
					var endX = e.clientX;
					var moveLen = resize.left + (endX - startX);
					var maxT = box.clientWidth - resize.offsetWidth;
					if(moveLen < 170) moveLen = 170;
					if(moveLen > maxT - 170) moveLen = maxT - 170;
					resize.style.left = moveLen;
					left.style.width = moveLen + "px";
					right.style.width = (box.clientWidth - moveLen - 2) + "px";
				}
				document.onmouseup = function(evt) {
					document.onmousemove = null;
					document.onmouseup = null;
					resize.releaseCapture && resize.releaseCapture();
				}
				resize.setCapture && resize.setCapture();
				return false;
			}
		}
	}
</script>

<style scoped>
	.treeBody {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 100%;
		width: 100%;
		/* background: #f0f0f0; */
	}
	.tree{
		/* color: #515A6E; */
		height: 100%;
		width: 4.1rem;
		/* overflow-y: scroll;
		overflow-x: hidden; */
	
		/* background: white; */
		/*border-right: 1px solid #cacaca;*/
	}
	#resize {
		line-height: 100%;
		width: 1px;
		height: 100%;
		cursor: w-resize;
		float: left;
		background-color: #cacaca;
	}
	#resize img{
		height: 100%;
		width: 10px;
	}
	.body{
		height: 100%;
		width: calc(100% - 4.11rem);
		overflow: hidden;
	}
</style>